module.exports = __webpack_public_path__ + "img/event_carpet_expoluxe_0024_blue_jean.4c842ad9.jpg";